import showSurvey from './show-survey';

export default {
  showSurvey,
};
